(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gsafe-faq"] && !Shopify.designMode) return;
  try {
    
  class GsafeFaq extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      // Grouped mode: tabs switch whole `.gsafe-faq__group` blocks (each
      // with its own sub-headings). Flat mode: tabs filter individual items.
      const grouped = this.querySelector('.gsafe-faq__group') !== null;

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('.gsafe-faq__tab');
        if (!tab) return;

        this.querySelectorAll('.gsafe-faq__tab').forEach((el) => {
          el.classList.remove('is-active');
          el.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const value = tab.dataset.category;

        if (grouped) {
          this.querySelectorAll('.gsafe-faq__group').forEach((group) => {
            const matches = group.dataset.category === value;
            group.classList.toggle('gsafe-faq__group--hidden', !matches);
            if (!matches) {
              group.querySelectorAll('.gsafe-faq__item[open]').forEach((i) => i.removeAttribute('open'));
            }
          });
        } else {
          this.querySelectorAll('.gsafe-faq__item').forEach((item) => {
            const matches = item.dataset.category === value;
            item.classList.toggle('gsafe-faq__item--hidden', !matches);
            if (!matches) item.removeAttribute('open');
          });
        }
      }, { signal });

      // Grouped tabs can be opened from a link, e.g. /pages/faq#faq-pepper-spray.
      const hash = window.location.hash.replace('#', '');
      if (hash) {
        const target = this.querySelector(`.gsafe-faq__tab[data-hash="${CSS.escape(hash)}"]`);
        if (target) {
          target.click();
          requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
        }
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('gsafe-faq', GsafeFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-featured-products"] && !Shopify.designMode) return;
  try {
    
  class GsafeProductsCartSync extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      // Quick-add forms in this grid submit straight to /cart/add.js and reuse
      // the theme's existing cart-drawer (the same 'ajaxProduct:added' event
      // classic add-to-cart buttons dispatch elsewhere in the theme).
      document.addEventListener('submit', (event) => {
        const form = event.target.closest('.gsafe-products__form');
        if (!form) return;

        event.preventDefault();

        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then((response) => {
            if (!response.ok) return response.json().then((err) => Promise.reject(err));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          })
          .catch((error) => {
            console.error('GSafe featured products: add to cart failed', error);
          })
          .finally(() => {
            if (submitButton) submitButton.disabled = false;
          });
      }, { signal });

      // Variant swatches swap the card's main image and update the hidden
      // variant id so Add to Cart adds the color the shopper actually picked.
      document.addEventListener('click', (event) => {
        const swatch = event.target.closest('.gsafe-products__swatch');
        if (!swatch) return;

        const card = swatch.closest('.gsafe-products__card');
        if (!card) return;

        card.querySelectorAll('.gsafe-products__swatch').forEach((el) => el.classList.remove('is-active'));
        swatch.classList.add('is-active');

        const mainImage = card.querySelector('.gsafe-products__main-image');
        if (mainImage && swatch.dataset.variantImage) {
          mainImage.src = swatch.dataset.variantImage;
          mainImage.removeAttribute('srcset');
        }

        const variantInput = card.querySelector('.gsafe-products__variant-input');
        if (variantInput && swatch.dataset.variantId) {
          variantInput.value = swatch.dataset.variantId;
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('gsafe-products-cart-sync', GsafeProductsCartSync);

  class GsafeProductsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gsafe-products__grid');
      this.prevBtn = this.querySelector('.gsafe-products__arrow--prev');
      this.nextBtn = this.querySelector('.gsafe-products__arrow--next');

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.prevBtn.addEventListener('click', () => this.go(-1), { signal });
      this.nextBtn.addEventListener('click', () => this.go(1), { signal });

      // Swipe dots (rendered just after this element) follow the scroll
      // position, and tapping one jumps to that card.
      const pager = this.nextElementSibling;
      this.dots = pager && pager.classList.contains('gsafe-products__pager')
        ? pager.querySelectorAll('.gsafe-products__dot')
        : [];
      if (this.dots.length) {
        let ticking = false;
        this.track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => { ticking = false; this.syncDots(); });
        }, { passive: true, signal });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)), { signal });
        });
      }

      this.initAutoHint(signal);
    }

    cardTarget(card) {
      const cardRect = card.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      return this.track.scrollLeft + (cardRect.left - trackRect.left) - (this.track.clientWidth - cardRect.width) / 2;
    }

    syncDots() {
      const cards = this.track.querySelectorAll('.gsafe-products__card');
      if (!cards.length) return;
      let best = 0;
      if (this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2) {
        best = cards.length - 1;
      } else {
        let bestD = Infinity;
        cards.forEach((card, i) => {
          const d = Math.abs(this.cardTarget(card) - this.track.scrollLeft);
          if (d < bestD) { bestD = d; best = i; }
        });
      }
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === best));
    }

    goTo(index) {
      const card = this.track.querySelectorAll('.gsafe-products__card')[index];
      if (!card) return;
      const to = Math.max(0, this.cardTarget(card));
      const from = this.track.scrollLeft;
      this.track.scrollTo({ left: to, behavior: 'smooth' });
      // Some touch browsers ignore smooth programmatic scroll — jump if it never started.
      setTimeout(() => {
        if (this.track.scrollLeft === from && Math.abs(from - to) > 4) this.track.scrollLeft = to;
      }, 150);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.cancelHint();
    }

    // Mobile 'you can swipe this' hint: once the row is mostly on screen,
    // slide forward to the 2nd, then the 3rd product, and stay there (no
    // return trip, so it doesn't look like only two products). Any touch/click/scroll
    // input inside the section cancels it for good. If the row leaves the
    // screen before the hint finishes, it snaps back and replays on return.
    initAutoHint(signal) {
      if (!this.hasAttribute('data-auto-hint')) return;
      if (!window.matchMedia('(max-width: 980px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      if (this.track.querySelectorAll('.gsafe-products__card').length < 2) return;

      this.hintTimers = [];
      this.hintState = 'idle'; // idle → running → done | cancelled

      const stop = () => {
        if (this.hintState === 'done' || this.hintState === 'cancelled') return;
        this.hintState = 'cancelled';
        this.cancelHint();
      };
      const pager = this.nextElementSibling;
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((type) => {
        this.addEventListener(type, stop, { passive: true, signal });
        pager?.addEventListener(type, stop, { passive: true, signal });
      });

      this.hintObserver = new IntersectionObserver((entries) => {
        const visible = entries[0].intersectionRatio >= 0.6;
        if (this.hintState === 'cancelled' || this.hintState === 'done') return;
        if (visible && this.hintState === 'idle') {
          this.hintState = 'running';
          const lastStep = Math.min(2, this.track.querySelectorAll('.gsafe-products__card').length - 1);
          for (let step = 1; step <= lastStep; step += 1) {
            this.hintTimers.push(setTimeout(() => this.goTo(step), 1200 + (step - 1) * 1700));
          }
          this.hintTimers.push(setTimeout(() => {
            this.hintState = 'done';
            this.cancelHint();
          }, 1200 + (lastStep - 1) * 1700 + 800));
        } else if (!visible && this.hintState === 'running') {
          // Left the screen mid-hint: reset quietly so it replays on return.
          this.hintTimers.forEach(clearTimeout);
          this.hintTimers = [];
          this.track.scrollLeft = 0;
          this.hintState = 'idle';
        }
      }, { threshold: [0, 0.6] });
      this.hintObserver.observe(this);
    }

    cancelHint() {
      this.hintTimers?.forEach(clearTimeout);
      this.hintTimers = [];
      this.hintObserver?.disconnect();
    }

    go(direction) {
      const cards = this.track.querySelectorAll('.gsafe-products__card');
      if (!cards.length) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = cards[0].getBoundingClientRect().width + gap;

      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const atStart = this.track.scrollLeft <= 2;

      if (direction > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && atStart) {
        this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }
    }
  }

  customElements.define('gsafe-products-carousel', GsafeProductsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-hero"] && !Shopify.designMode) return;
  try {
    
  class GsafeHeroStats extends HTMLElement {
    connectedCallback() {
      this.animated = false;
      this.run();

      if (!Shopify.designMode) return;
      this.addEventListener('shopify:section:load', () => this.run());
    }

    run() {
      if (this.animated) return;
      this.animated = true;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const els = this.querySelectorAll('[data-count-target]');

      els.forEach((el) => {
        const raw = el.dataset.countTarget || '';
        const match = raw.match(/^([\d]+(?:\.\d+)?)(.*)$/);
        if (!match) return;

        const targetValue = parseFloat(match[1]);
        const decimals = match[1].includes('.') ? match[1].split('.')[1].length : 0;
        const suffix = match[2];

        if (prefersReducedMotion || isNaN(targetValue)) {
          el.textContent = raw;
          return;
        }

        // Stats like "10K+" only have a target of 10 (the "K" is just
        // part of the suffix), which is too coarse to look like it's
        // "flashing" through numbers. Show an extra decimal during the
        // count for those so it visibly ticks 1.1K, 1.2K, 1.3K... before
        // landing on the real value.
        const animDecimals = /k/i.test(suffix) ? Math.max(decimals, 1) : decimals;

        el.textContent = (0).toFixed(animDecimals) + suffix;

        const duration = 2000;
        const start = performance.now();

        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          // Linear, not eased — keeps the digits changing at a fast,
          // constant, "flashing" rate for the full 2s instead of
          // slowing down and settling near the end.
          const current = (targetValue * progress).toFixed(animDecimals);
          el.textContent = current + suffix;

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            el.textContent = raw;
          }
        };

        requestAnimationFrame(step);
      });
    }
  }

  customElements.define('gsafe-hero-stats', GsafeHeroStats);

  class GsafeBadgeCount extends HTMLElement {
    connectedCallback() {
      this.animated = false;
      this.run();

      if (!Shopify.designMode) return;
      this.addEventListener('shopify:section:load', () => this.run());
    }

    run() {
      if (this.animated) return;
      this.animated = true;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const raw = this.textContent;
      const match = raw.match(/\d{1,3}(?:,\d{3})+|\d+/);

      if (prefersReducedMotion || !match) return;

      const numText = match[0];
      const targetValue = parseInt(numText.replace(/,/g, ''), 10);
      if (isNaN(targetValue)) return;

      const prefix = raw.slice(0, match.index);
      const suffix = raw.slice(match.index + numText.length);
      const countEl = document.createElement('span');

      this.textContent = '';
      this.append(prefix, countEl, suffix);
      countEl.textContent = '0';

      const duration = 2000;
      const start = performance.now();

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        countEl.textContent = Math.round(targetValue * progress).toLocaleString('en-US');

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          countEl.textContent = numText;
        }
      };

      requestAnimationFrame(step);
    }
  }

  customElements.define('gsafe-badge-count', GsafeBadgeCount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-pdp-carry"] && !Shopify.designMode) return;
  try {
    
  // Prev/next arrows over the card strip so shoppers can see there are
  // more cards and page through them without swiping. Now shown at every
  // width (previously mobile-only) since the strip itself is universal.
  // Each arrow fades out at its end of the strip.
  class GsafePdpCarryCards extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-carry-scroller]');
      this.prev = this.querySelector('[data-carry-prev]');
      this.next = this.querySelector('[data-carry-next]');
      if (!this.scroller || !this.prev || !this.next) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      // one card + the flex gap
      const step = () => {
        const card = this.scroller.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 16;
        return card ? card.getBoundingClientRect().width + gap : this.scroller.clientWidth * 0.8;
      };

      this.prev.addEventListener('click', () => {
        this.scroller.scrollBy({ left: -step(), behavior: 'smooth' });
      }, { signal });
      this.next.addEventListener('click', () => {
        this.scroller.scrollBy({ left: step(), behavior: 'smooth' });
      }, { signal });

      const sync = () => {
        const max = this.scroller.scrollWidth - this.scroller.clientWidth;
        this.prev.classList.toggle('is-off', this.scroller.scrollLeft <= 2);
        this.next.classList.toggle('is-off', this.scroller.scrollLeft >= max - 2);
      };
      this.scroller.addEventListener('scroll', sync, { passive: true, signal });
      window.addEventListener('resize', sync, { passive: true, signal });
      sync();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('gsafe-pdp-carry-cards', GsafePdpCarryCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-pdp-editorial-photo"] && !Shopify.designMode) return;
  try {
    
  class GsafePdpRepeatBuybox extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      const form = this.querySelector('.gsafe-pdp-repeat__form');
      const btn = this.querySelector('[data-repeat-add]');

      form?.addEventListener('submit', (event) => {
        event.preventDefault();
        btn.disabled = true;

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then((response) => {
            if (!response.ok) return response.json().then((err) => Promise.reject(err));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          })
          .catch(() => {})
          .finally(() => {
            btn.disabled = false;
          });
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('gsafe-pdp-repeat-buybox', GsafePdpRepeatBuybox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-pdp-how-to-use"] && !Shopify.designMode) return;
  try {
    
  // Same tab-switching technique as GsafeFaq in gsafe-faq.liquid: click
  // delegation + AbortController cleanup, toggling an `is-active` class on
  // the clicked tab and a `--hidden` class on non-matching cards via a
  // data-tab match. Only instantiated when the tab bar actually renders
  // (0/1 unique tab values skip the tab markup entirely), so this custom
  // element is inert on Pepper Spray/the Alarm.
  class GsafePdpStepsTabs extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.scrollWrap = this.querySelector('[data-tabs-scroll]');
      this.strip = this.querySelector('.gsafe-pdp-steps__tabs');

      // Right-edge fade + chevron: on while the tab row can still scroll
      // right, off once the last tab is reached — so the row visibly
      // reads as swipeable when the tabs overflow their container.
      const syncScroll = () => {
        if (!this.scrollWrap || !this.strip) return;
        const overflow = this.strip.scrollWidth - this.strip.clientWidth;
        this.scrollWrap.classList.toggle('is-scrollable', overflow > 4);
        this.scrollWrap.classList.toggle('is-end', this.strip.scrollLeft >= overflow - 4);
      };
      this.syncScroll = syncScroll;

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('.gsafe-pdp-steps__tab');
        if (!tab) return;

        this.querySelectorAll('.gsafe-pdp-steps__tab').forEach((el) => {
          el.classList.remove('is-active');
          el.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const selectedTab = tab.dataset.tab;
        this.querySelectorAll('.gsafe-pdp-steps__card').forEach((card) => {
          card.classList.toggle('gsafe-pdp-steps__card--hidden', card.dataset.tab !== selectedTab);
        });

        // Pull a partially-hidden tab into view without moving the page.
        // Uses instant, not smooth: programmatic smooth scroll is silently
        // dropped on touch devices here, so smooth would just no-op.
        if (this.strip) {
          const t = tab.getBoundingClientRect();
          const s = this.strip.getBoundingClientRect();
          this.strip.scrollBy({ left: (t.left + t.width / 2) - (s.left + s.width / 2) });
          syncScroll();
        }
      }, { signal });

      if (this.scrollWrap && this.strip) {
        this.strip.addEventListener('scroll', syncScroll, { passive: true, signal });
        window.addEventListener('resize', syncScroll, { passive: true, signal });
        syncScroll();
      }

      // A link like #htu-pepper-spray opens that tab and scrolls here
      // (used by the How To Use page's product picker).
      const openFromHash = () => {
        const hash = window.location.hash.replace('#', '');
        if (!hash) return;
        const tab = this.querySelector(`.gsafe-pdp-steps__tab[data-hash="${CSS.escape(hash)}"]`);
        if (!tab) return;
        tab.click();
        const section = this.closest('.gsafe-pdp-steps') || this;
        requestAnimationFrame(() => section.scrollIntoView({ block: 'start' }));
      };
      window.addEventListener('hashchange', openFromHash, { signal });
      openFromHash();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('gsafe-pdp-steps-tabs', GsafePdpStepsTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-pdp-main"]) return;
  try {
    
  class GsafePdpMain extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.variants = JSON.parse(this.querySelector('[data-pdp-variants]').textContent || '[]');

      this.variantInputEl = this.querySelector('[data-pdp-variant-input]');
      this.priceEl = this.querySelector('[data-pdp-price]');
      this.comparePriceEl = this.querySelector('[data-pdp-compare-price]');
      this.addBtn = this.querySelector('[data-pdp-add-btn]');
      this.mainImageEl = this.querySelector('[data-pdp-main-image]');
      this.swatchLabelEl = this.querySelector('[data-pdp-swatch-label]');
      this.form = this.querySelector('.gsafe-pdp-buybox__form');

      this.stickyBar = this.querySelector('[data-pdp-sticky]');
      this.stickyImage = this.querySelector('[data-pdp-sticky-image]');
      this.stickyPrice = this.querySelector('[data-pdp-sticky-price]');

      this.initGallery(signal);
      this.initVariantSync(signal);
      this.initSwatches(signal);
      this.initAddToCart(signal);
      this.initStickyAdd(signal);
      this.initStickyBar(signal);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initGallery(signal) {
      this.slidesEl = this.querySelector('[data-pdp-slides]');
      this.slideEls = Array.from(this.querySelectorAll('[data-pdp-slide]'));
      this.thumbEls = Array.from(this.querySelectorAll('[data-pdp-thumb]'));

      // Thumb N corresponds to slide N (same filtered media loop)
      this.thumbEls.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this.goToSlide(i), { signal });
      });

      // Swiping the main image updates the active thumb
      this.slidesEl?.addEventListener('scroll', () => {
        if (this.mainImageEl) this.mainImageEl.hidden = true;
        clearTimeout(this.slideScrollTimer);
        this.slideScrollTimer = setTimeout(() => {
          const i = Math.round(this.slidesEl.scrollLeft / this.slidesEl.clientWidth);
          this.setActiveThumb(i);
        }, 80);
      }, { passive: true, signal });
    }

    setActiveThumb(i) {
      this.thumbEls.forEach((t, k) => t.classList.toggle('is-active', k === i));
      this.thumbEls[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    goToSlide(i) {
      if (!this.slidesEl || i < 0 || i >= this.slideEls.length) return;
      if (this.mainImageEl) this.mainImageEl.hidden = true;
      this.slidesEl.scrollTo({ left: this.slidesEl.clientWidth * i, behavior: 'smooth' });
      this.setActiveThumb(i);
    }

    setMainImage(url) {
      if (!url) return;
      // Jump to the matching slide. URLs can differ in width/query params AND
      // host prefix (variant JSON uses //domain/cdn/..., slides use /cdn/...),
      // so compare only the path from /cdn/ onward.
      const norm = (u) => {
        const b = (u || '').split('?')[0];
        const at = b.indexOf('/cdn/');
        return at >= 0 ? b.slice(at) : b;
      };
      const base = norm(url);
      const i = this.slideEls.findIndex((s) => norm(s.dataset.full) === base);
      if (i >= 0) {
        this.goToSlide(i);
        return;
      }
      // Variant image isn't in the gallery (hidden by setting) — show it in
      // the overlay instead, like the old swap behavior
      if (this.mainImageEl) {
        this.mainImageEl.src = url;
        this.mainImageEl.hidden = false;
      }
    }

    initVariantSync(signal) {
      // Ka-ching Bundles owns the visible variant picker, but it writes the
      // selection into this form's [name="id"] input and dispatches a change
      // event on it — mirror that into the gallery and sticky bar so picking
      // a colorway swaps the main photo again.
      this.variantInputEl?.addEventListener('change', () => {
        const variant = this.variants.find((v) => String(v.id) === String(this.variantInputEl.value));
        if (!variant) return;
        if (variant.image) this.setMainImage(variant.image);
        if (this.stickyPrice && variant.price) this.stickyPrice.textContent = variant.price;
        if (this.stickyImage && variant.image) this.stickyImage.src = variant.image;
      }, { signal });
    }

    initSwatches(signal) {
      this.querySelectorAll('[data-pdp-swatch]').forEach((swatch) => {
        swatch.addEventListener('click', () => {
          this.querySelectorAll('[data-pdp-swatch]').forEach((s) => s.classList.remove('is-active'));
          swatch.classList.add('is-active');
          if (this.swatchLabelEl) this.swatchLabelEl.textContent = swatch.dataset.label;

          const variantId = swatch.dataset.variantId;
          this.variantInputEl.value = variantId;

          const variant = this.variants.find((v) => String(v.id) === String(variantId));
          if (!variant) return;

          if (this.priceEl) this.priceEl.textContent = variant.price;
          if (this.comparePriceEl) {
            if (variant.compareAtPrice && variant.compareAtPrice !== variant.price) {
              this.comparePriceEl.textContent = variant.compareAtPrice;
              this.comparePriceEl.hidden = false;
            } else {
              this.comparePriceEl.hidden = true;
            }
          }
          if (variant.image) this.setMainImage(variant.image);
          this.stickyPrice.textContent = variant.price;
          if (variant.image) this.stickyImage.src = variant.image;

          this.addBtn.disabled = !variant.available;
          this.addBtn.querySelector('[data-pdp-add-btn-text]').textContent = variant.available
            ? 'Add to Cart'
            : 'Sold Out';
        }, { signal });
      });
    }

    addToCart() {
      const formData = new FormData(this.form);
      return fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then((response) => {
        if (!response.ok) return response.json().then((err) => Promise.reject(err));
        return response.json();
      });
    }

    initAddToCart(signal) {
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.addBtn.disabled = true;
        this.addToCart()
          .then(() => {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          })
          .catch(() => {})
          .finally(() => {
            this.addBtn.disabled = false;
          });
      }, { signal });
    }

    initStickyAdd(signal) {
      this.querySelector('[data-pdp-sticky-add]')?.addEventListener('click', () => {
        this.addToCart().then(() => {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        }).catch(() => {});
      }, { signal });
    }

    // When a Kaching bundle is on the page, show its selected bundle price
    // (what actually goes in the cart) instead of the single variant price.
    syncStickyPrice() {
      if (!this.stickyPrice) return;
      const bundlePrice = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
      if (bundlePrice && bundlePrice.textContent.trim()) {
        this.stickyPrice.textContent = bundlePrice.textContent.trim();
      }
    }

    initStickyBar(signal) {
      window.addEventListener('scroll', () => {
        const trigger = this.offsetTop + this.querySelector('.gsafe-pdp-main__wrap').offsetHeight;
        if (window.scrollY > trigger) {
          if (!this.stickyBar.classList.contains('is-visible')) this.syncStickyPrice();
          this.stickyBar.classList.add('is-visible');
        } else {
          this.stickyBar.classList.remove('is-visible');
        }
      }, { signal, passive: true });
    }
  }

  customElements.define('gsafe-pdp-main', GsafePdpMain);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  class GsafePdpReviewsList extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.querySelector('[data-reviews-show-more]')?.addEventListener('click', () => {
        this.classList.add('is-expanded');
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('gsafe-pdp-reviews-list', GsafePdpReviewsList);

  // Hide the review skeleton as soon as Ryviu has drawn its list. Ryviu
  // starts loading once the shopper scrolls the reviews into view, so the
  // safety timeout (in case Ryviu never draws) only starts at that point.
  (() => {
    document.querySelectorAll('[data-reviews-app].is-loading').forEach((app) => {
      const widget = app.querySelector('ryviu-widget');
      if (!widget) { app.classList.remove('is-loading'); app.classList.add('is-empty'); return; }
      if (widget.childElementCount > 0) { app.classList.remove('is-loading'); return; }

      let timer;
      const done = () => {
        app.classList.remove('is-loading');
        mutation.disconnect();
        visibility?.disconnect();
        clearTimeout(timer);
      };
      const mutation = new MutationObserver(() => {
        if (widget.childElementCount > 0) done();
      });
      mutation.observe(widget, { childList: true, subtree: true });

      const startTimeout = () => { timer = timer || setTimeout(done, 15000); };
      const visibility = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) startTimeout();
          })
        : null;
      if (visibility) visibility.observe(app); else startTimeout();
    });
  })();

  // Ryviu can render its review list inside a shadow root, where theme CSS
  // can't reach. Inject a tiny style there to hide the "Showing 1 - 10 of N
  // reviews" line. Ryviu builds the widget asynchronously, so keep checking
  // for a while after load.
  (() => {
    const CSS = '.r--text-showing{display:none!important}';
    const patch = () => {
      document.querySelectorAll('.gsafe-pdp-reviews ryviu-widget').forEach((w) => {
        const root = w.shadowRoot;
        if (root && !root.querySelector('style[data-gsafe-hide-count]')) {
          const s = document.createElement('style');
          s.setAttribute('data-gsafe-hide-count', '');
          s.textContent = CSS;
          root.appendChild(s);
        }
      });
    };
    let tries = 0;
    const timer = setInterval(() => {
      patch();
      if (++tries > 40) clearInterval(timer); // ~20s
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-pdp-specs"] && !Shopify.designMode) return;
  try {
    
  // Count-up for stat chip values on scroll-into-view — same 2s linear
  // "flashing digits" effect as the homepage hero stats (gsafe-hero.liquid),
  // but every number in the string animates ("60–70" ticks both numbers,
  // "Up to 6 ft" ticks the 6). Values without digits are left untouched.
  class GsafePdpSpecChips extends HTMLElement {
    connectedCallback() {
      this.animated = false;

      if (!('IntersectionObserver' in window)) {
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.observer.disconnect();
          this.run();
        }
      }, { threshold: 0.3 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    run() {
      if (this.animated) return;
      this.animated = true;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('[data-chip-count]').forEach((el) => {
        const raw = el.textContent;
        if (prefersReducedMotion || !/\d/.test(raw)) return;

        const duration = 2000;
        const start = performance.now();

        const step = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          if (progress < 1) {
            // Linear, not eased — constant "flashing" digit rate (matches hero)
            el.textContent = raw.replace(/\d+/g, (n) => Math.round(parseInt(n, 10) * progress));
            requestAnimationFrame(step);
          } else {
            el.textContent = raw;
          }
        };

        requestAnimationFrame(step);
      });
    }
  }

  customElements.define('gsafe-pdp-spec-chips', GsafePdpSpecChips);

  // Product tabs (bundle pages only): clicking a tab shows that product's
  // chips + spec rows and hides the rest. Inert when there are no tab
  // buttons — single-product pages render no tab bar at all.
  class GsafePdpSpecsTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.gsafe-pdp-specs__tab'));
      if (!this.tabs.length) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.addEventListener('click', (event) => {
        const btn = event.target.closest('.gsafe-pdp-specs__tab');
        if (!btn) return;
        const value = btn.dataset.specTab;

        this.tabs.forEach((t) => {
          const active = t === btn;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        this.querySelectorAll('[data-spec-panel]').forEach((el) => {
          el.classList.toggle('is-hidden-tab', el.dataset.specPanel !== value);
        });
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('gsafe-pdp-specs-tabs', GsafePdpSpecsTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-press"] && !Shopify.designMode) return;
  try {
    
  class GsafePressCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gsafe-press__grid');
      this.prevBtn = this.querySelector('.gsafe-press__arrow--prev');
      this.nextBtn = this.querySelector('.gsafe-press__arrow--next');
      if (!this.track) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.prevBtn?.addEventListener('click', () => this.go(-1), { signal });
      this.nextBtn?.addEventListener('click', () => this.go(1), { signal });

      this.addEventListener('click', (event) => {
        const card = event.target.closest('.gsafe-press__card');
        if (!card) return;
        const dialog = document.getElementById(card.dataset.modalTarget);
        dialog?.showModal();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    go(direction) {
      const cards = this.track.querySelectorAll('.gsafe-press__card');
      if (!cards.length) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = cards[0].getBoundingClientRect().width + gap;

      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const atStart = this.track.scrollLeft <= 2;

      if (direction > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && atStart) {
        this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }
    }
  }

  customElements.define('gsafe-press-carousel', GsafePressCarousel);

  document.addEventListener('click', (event) => {
    const closeBtn = event.target.closest('.gsafe-press__dialog-close');
    if (closeBtn) {
      closeBtn.closest('dialog')?.close();
      return;
    }

    const arrow = event.target.closest('.gsafe-press__dialog-arrow');
    if (arrow) {
      const track = arrow.closest('.gsafe-press__dialog-photos-wrap')?.querySelector('.gsafe-press__dialog-photos');
      if (!track) return;

      const items = track.querySelectorAll('image-element, .gsafe-press__dialog-photo');
      if (!items.length) return;

      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = items[0].getBoundingClientRect().width + gap;
      const direction = arrow.classList.contains('gsafe-press__dialog-arrow--next') ? 1 : -1;

      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      const atStart = track.scrollLeft <= 2;

      if (direction > 0 && atEnd) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && atStart) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }
      return;
    }

    if (event.target.classList?.contains('gsafe-press__dialog')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-testimonials"] && !Shopify.designMode) return;
  try {
    
  class GsafeTestimonials extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gsafe-testimonials__track');
      this.prevBtn = this.querySelector('.gsafe-testimonials__arrow--prev');
      this.nextBtn = this.querySelector('.gsafe-testimonials__arrow--next');

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.prevBtn.addEventListener('click', () => this.go(-1), { signal });
      this.nextBtn.addEventListener('click', () => this.go(1), { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    go(direction) {
      const cards = this.track.querySelectorAll('.gsafe-testimonials__card');
      if (!cards.length) return;

      const cardWidth = cards[0].getBoundingClientRect().width + 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = cardWidth + gap;

      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const atStart = this.track.scrollLeft <= 2;

      if (direction > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && atStart) {
        this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }
    }
  }

  customElements.define('gsafe-testimonials', GsafeTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-ugc-videos"] && !Shopify.designMode) return;
  try {
    
  class GsafeUgcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gsafe-ugc__grid');
      this.prevBtn = this.querySelector('.gsafe-ugc__arrow--prev');
      this.nextBtn = this.querySelector('.gsafe-ugc__arrow--next');
      if (!this.track) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.prevBtn?.addEventListener('click', () => this.go(-1), { signal });
      this.nextBtn?.addEventListener('click', () => this.go(1), { signal });

      const previews = this.querySelectorAll('.gsafe-ugc__preview');

      previews.forEach((video) => {
        const maxSeconds = parseFloat(video.dataset.loopSeconds) || 3;
        video.addEventListener('timeupdate', () => {
          if (video.currentTime >= maxSeconds) {
            video.currentTime = 0;
            video.play().catch(() => {});
          }
        }, { signal });
      });

      // Only autoplay cards actually visible within the carousel's own
      // scroll area — off-screen cards stay paused until the shopper
      // swipes/scrolls them into view. Uses direct bounding-box checks
      // (not IntersectionObserver, whose first callback can be delayed
      // in some browsers) so the correct cards are playing immediately.
      const isVisible = (video) => {
        const trackRect = this.track.getBoundingClientRect();
        const videoRect = video.getBoundingClientRect();
        const visibleWidth = Math.min(videoRect.right, trackRect.right) - Math.max(videoRect.left, trackRect.left);
        return (Math.max(0, visibleWidth) / videoRect.width) >= 0.6;
      };

      // Vertical gate: don't play (and so don't download) anything until the
      // section is near the viewport; pause everything once it's scrolled away.
      this.inView = false;
      if ('IntersectionObserver' in window) {
        this.sectionObserver = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          syncVisibility();
        }, { rootMargin: '300px 0px' });
        this.sectionObserver.observe(this);
      } else {
        this.inView = true;
      }

      const syncVisibility = () => {
        previews.forEach((video, index) => {
          if (this.inView && isVisible(video)) {
            if (video.paused) {
              // Stagger simultaneous play() calls slightly — calling
              // .play() on several <video> elements in the same tick can
              // cause a browser to interrupt an earlier call's promise.
              setTimeout(() => video.play().catch(() => {}), index * 60);
            }
          } else {
            video.pause();
          }
        });
      };

      syncVisibility();

      this.track.addEventListener('scroll', () => {
        clearTimeout(this._scrollSyncTimeout);
        this._scrollSyncTimeout = setTimeout(syncVisibility, 120);
      }, { signal, passive: true });

      this.addEventListener('click', (event) => {
        const card = event.target.closest('.gsafe-ugc__card');
        if (!card) return;
        const dialog = document.getElementById(card.dataset.modalTarget);
        if (!dialog) return;

        this.querySelectorAll('.gsafe-ugc__preview').forEach((v) => v.pause());

        dialog.showModal();
        const dialogVideo = dialog.querySelector('.gsafe-ugc__dialog-video');
        if (dialogVideo) {
          dialogVideo.muted = false;
          dialogVideo.currentTime = 0;
          dialogVideo.play().catch(() => {});
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.sectionObserver?.disconnect();
      clearTimeout(this._scrollSyncTimeout);
    }

    go(direction) {
      const cards = this.track.querySelectorAll('.gsafe-ugc__card');
      if (!cards.length) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = cards[0].getBoundingClientRect().width + gap;

      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const atStart = this.track.scrollLeft <= 2;

      if (direction > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && atStart) {
        this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }
    }
  }

  customElements.define('gsafe-ugc-carousel', GsafeUgcCarousel);

  document.addEventListener('click', (event) => {
    const closeBtn = event.target.closest('.gsafe-ugc__dialog-close');
    if (closeBtn) {
      const dialog = closeBtn.closest('dialog');
      dialog?.querySelector('video')?.pause();
      dialog?.close();
      return;
    }

    if (event.target.matches('.gsafe-ugc__dialog')) {
      event.target.querySelector('video')?.pause();
      event.target.close();
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target.classList?.contains('gsafe-ugc__dialog')) {
      event.target.querySelector('video')?.pause();
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsafe-video-guide"] && !Shopify.designMode) return;
  try {
    
  class GsafeVideoGuide extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.overlay = this.querySelector('.gsafe-video-guide__play-overlay');
      this.chapters = Array.from(this.querySelectorAll('.gsafe-video-guide__chapter'));
      if (!this.video) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.playFromOverlay(), { signal });
      }

      this.chapters.forEach((chapter) => {
        chapter.addEventListener('click', () => {
          const seconds = this.parseTime(chapter.dataset.time);
          if (seconds === null) return;
          this.overlay?.classList.add('is-hidden');
          this.video.currentTime = seconds;
          this.video.play();
        }, { signal });
      });

      this.video.addEventListener('timeupdate', () => this.updateActiveChapter(), { signal });
    }

    playFromOverlay() {
      this.overlay?.classList.add('is-hidden');
      this.video.play();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    parseTime(value) {
      if (!value) return null;
      const parts = value.split(':').map((p) => parseInt(p, 10));
      if (parts.some((p) => isNaN(p))) return null;
      return parts.reduce((total, part) => total * 60 + part, 0);
    }

    updateActiveChapter() {
      const current = this.video.currentTime;
      let activeChapter = null;

      this.chapters.forEach((chapter) => {
        const seconds = this.parseTime(chapter.dataset.time);
        if (seconds !== null && seconds <= current) {
          if (!activeChapter || seconds > this.parseTime(activeChapter.dataset.time)) {
            activeChapter = chapter;
          }
        }
      });

      this.chapters.forEach((chapter) => {
        chapter.classList.toggle('is-active', chapter === activeChapter);
      });
    }
  }

  customElements.define('gsafe-video-guide', GsafeVideoGuide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
